import config from '../Config';
import RequestRabbit from './RequestRabbit';

const useErrorLogSearch = () => {
  const searchErrorLog = async (searchObject, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/errorlog`;
      const headers = new Headers({ 'Content-Type': 'application/json' });
      const options = {
        method: 'POST',
        body: JSON.stringify(searchObject) || null,
        headers: headers,
      };

      // Request
      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      // Response
      if (response.status > 399 && response.status < 600) {
        errorHandler(responseJSON.error);
        return [];
      }
      // console.log(responseJSON);
      return responseJSON;
    } catch (e) {
      errorHandler(e);
      return [];
    }
  };

  return { searchErrorLog };
};

export default useErrorLogSearch;
